export default __webpack_public_path__ + "static/media/ico_user_blue.12fc59c9.svg";